import styles from "./AdvantagesSection.module.css";
import clockImg from "../../images/clockImg.png";
import carImg from "../../images/simpleCarImg.png";
import guardImg from "../../images/achievmentShield.webp";
import doubleCheckImg from "../../images/doubleCheckImg.png";
import cityImg from "../../images/cityImg.png";
import moneyImg from "../../images/moneyStackImg.png";

export default function AdvantagesSection(){
  return(
    <div className={styles.advantages}>
      <p className={styles.advantages__title}>Наши преимущества</p>
      <div className={styles.advantages__grid}>
      <div className={styles.advantages__gridCell}>
          <img className={styles.advantages__image} src={cityImg} alt="" />
          <p className={styles.advantages__gridCellText}>Работаем в Санкт-Петербурге<br />и Ленинградской области</p>
        </div>
        <div className={styles.advantages__gridCell}>
          <img className={styles.advantages__image} src={clockImg} alt="" />
          <p className={styles.advantages__gridCellText}>6 лет<br /> успешной работы</p>
        </div>
        <div className={styles.advantages__gridCell}>
          <img className={`${styles.advantages__image} ${styles.advantages__image_car}`} src={carImg} alt="" />
          <p className={styles.advantages__gridCellText}>Более 1000 выкупленных<br />автомобилей</p>
        </div>
        <div className={styles.advantages__gridCell}>
          <img className={styles.advantages__image} src={guardImg} alt="" />
          <p className={styles.advantages__gridCellText}>Полная гарантия и<br />прозрачность сделки</p>
        </div>
        <div className={styles.advantages__gridCell}>
          <img className={`${styles.advantages__image} ${styles.advantages__image_dc}`} src={doubleCheckImg} alt="" />
          <p className={styles.advantages__gridCellText}>Деньги в день<br />обращения</p>
        </div>
        <div className={styles.advantages__gridCell}>
          <img className={`${styles.advantages__image} ${styles.advantages__image_money}`} src={moneyImg} alt="" />
          <p className={styles.advantages__gridCellText}>Выкупаем по цене до<br />98% от рыночной стоимости</p>
        </div>
      </div>
    </div>
  )
}